<template>
  <div class="rules-page">
    <p class="title" style="margin-top: 0">一、活动名称</p>
    <p class="content">国庆红包寻宝。</p>
    <p class="title">二、活动时间</p>
    <p class="content">自2021年9月30日00时00分起至2021年10月12日23时59分止。</p>
    <p class="title">三、活动参与者资格 </p>
    <p class="content">本活动的参与者（下称：您）应具备以下全部资格：</p>
    <p class="content">本活动参与者应为具有完全民事行为能力的自然人，每个自然人仅可使用一个自己合法有效且完成实名认证的企鹅汇图账号参与活动，否则您的全部参与行为将被视为无效，且无权获得任何现金及红包奖励。</p>
    <p class="title">四、活动规则</p>
    <p class="content title2">活动周期</p>
    <p class="content">预约期：自2021年9月30日00时00分起至2021年10月7日23时59分止。</p>
    <p class="content">活动期：自2021年10月8日00时00分起至2021年10月12日23时59分止。</p>
    <p class="content">膨胀日：自2021年10月12日00时00分起至2021年10月12日23时59分止。</p>
    <p class="content title2">参与方式</p>
    <p class="content content-2">1、预约有礼规则：预约期内，用户可进行活动预约（预约用户限量6万，达到预约量后，预约活动停止，无法继续进行预约）；成功预约的用户，在活动期内首次提交企鹅汇图APP中图像拍摄任务（含驾车任务、步骑任务）（下述简称为“任务”），必得1个奖励红包，奖励红包金额随机。该奖励红包每个用户最多获得一个，且无法转赠、无法叠加使用。（奖励红包详细规则见下述“奖励红包规则”）。</p>
    <p class="content content-2">2、红包寻宝规则：活动期内，用户提交任务，即可参与抽奖励红包活动；活动期内每提交1个任务（任务类型不限），可进行1次奖励红包抽取，奖励红包金额随机，所有的红包奖励均仅能在任务审核通过后方可获得。（奖励红包详细规则见下述“奖励红包规则”）。</p>
    <p class="content">3、膨胀日规则：膨胀日内，用户提交任务，即可参与膨胀日活动；膨胀日首次提交任务，可得1张膨胀卡，膨胀卡可用于奖励红包膨胀，膨胀卡详细规则见下方“膨胀卡规则”。 所有的红包奖励（包括使用膨胀卡所获的奖励）均仅能在任务审核通过后方可获得。</p>
    <p class="content title2">奖励红包规则</p>
    <p class="content content-2">1、红包获取方式：见上述参与方式。</p>
    <p class="content">2、红包设置：</p>
    <img src="@/assets/image/table.png" style="width: 100%; margin: 8.5px 0" alt="">
    <p class="content content-2">任何奖品红包被抽中后，下次抽取时该奖品红包所对应的抽取概率将由剩余奖品红包数量依据上一次的相应抽取概率按比例瓜分，总中奖概率不变。（即用户抽中红包后，下一次提交任务抽中红包概率依然为8%，不保证提交100个任务，一定抽中8个红包。）。</p>
    <p class="content content-2">3、任务审核及对应奖励红包规则：用户获得的所有奖励红包均为“预得红包”，所有预得红包均在提交具体任务后即可获得，但并不意味着所有的预得红包金额均能全额百分百转化为用户实际会得到的金额。如用户提交的任务审核通过，则该任务所获得的预得红包转为有效红包（包括参与膨胀日活动膨胀的金额），如任务审核不通过，则该任务所获得的预得红包为无效红包（包括参与膨胀日活动膨胀的金额），用户最终无法获得这部分的奖励，膨胀的金额也将对应的扣减。用户活动期所实际获得的奖励红包为有效红包的加总。任务审核进度及状态，可在本活动页面的“红包明细”中进行查看，任务审核时间一般为提交后7个工作日内，如遇高峰期，会有所延迟，请您耐心等待。为对您造成不必要的损失，提升您的审核通过率，请您按照《拍摄规范》进行任务拍摄。</p>
    <p class="content">4、红包到账：活动期所最终实际获得的有效红包金额（包括参与膨胀日活动后累计的金额）将于2021年10月22日23时59分前自动转入您的企鹅汇图APP“可提现金额”中，转入记录可在“企鹅汇图APP→收入明细→红包收入”中进行查看。</p>
    <p class="content title2">膨胀卡规则：</p>
    <p class="content content-2">1、膨胀卡获得：膨胀日首次提交任务，可得1张膨胀卡，膨胀卡每位用户最多只可获得1张。</p>
    <p class="content content-2">2、膨胀卡使用：膨胀卡可用于奖励红包膨胀，获得膨胀卡后，用户需在膨胀卡的活动页面点击使用，在使用膨胀卡时用户已经累计获得的奖励红包金额将进行随机系数膨胀（膨胀系数范围1.05-3，示例：若用户A使用膨胀卡前红包金额为10元，膨胀卡随机开出膨胀系数1.5，则用户使用膨胀卡后红包金额膨胀为15元）。若您使用膨胀卡、完成金额膨胀后，再获得奖励红包，则这部分奖励红包，不能进行膨胀。</p>
    <p class="content">3、膨胀卡有效期：膨胀卡有效期起始时间为您获得时间，失效时间为2021年10月12日23时59分。超出有效期后，膨胀卡自动失效，不能使用。</p>
    <p class="title ">五、参与资格、获奖资格的取消</p>
    <p class="content">您若有下列任何一种行为或情况的，腾讯有权单方面取消您的参与资格、获奖资格等：</p>
    <p class="content">1、不符合参与资格的。</p>
    <p class="content">2、提供虚假信息的。</p>
    <p class="content">3、虚假交易或恶意破坏活动的。</p>
    <p class="content">4、以任何机器人软件、蜘蛛软件、爬虫软件、刷奖软件或其它任何自动方式、不正当手段等参与本活动的。</p>
    <p class="content">5、有任何违反诚实信用、公序良俗、公平、公正等原则行为的。</p>
    <p class="content">6、其他违反相关法规、本规则行为的。</p>
    <p class="content">请用户理性参与活动，活动期间，如用户存在违反法律、法规或违反包括但不限于《企鹅汇图软件许可及服务协议》及活动合作平台规则，腾讯公司有权取消用户中奖资格，撤销违规交易，收回奖品或权益。</p>
    <p class="title">六、纳税义务</p>
    <p class="content">主办方将依法履行个人所得税等相关税费代扣代缴的义务。</p>
    <p class="title">七、免责条款</p>
    <p class="content">如因非腾讯原因导致您在本规则约定时间内未参与活动、兑换奖品或领取奖品，或由于您提供的信息不真实不完整等导致奖品无法发放或发放错误的，由您自行承担全部损失。</p>
    <p class="title">八、管辖条款</p>
    <p class="content">本规则的成立、生效、履行、解释及纠纷解决等相关事宜，均适用中华人民共和国大陆地区法律（不包括冲突法）。若您和腾讯之间发生任何纠纷或争议应将纠纷或争议提交本规则签订地即深圳市南山区有管辖权的人民法院管辖。</p>


  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  setup() {
    
  },
})
</script>

<style lang="scss" scoped>
.rules-page {
  padding: 19.79px 25px;
  p {
    line-height: 22.93px;
    font-size: 14px;
    color: #17181A;
    text-align: justify;
  }
  .content {
    // padding: 0 13.54px;
    opacity: .8;
  }
  .content-2 {
    margin-bottom: 16.67px;
  }
  .title {
    font-size: 16.67px;
    color: #EC0921;
    margin: 25px 0 8.33px 0;
    font-weight: bold;
    // opacity: 1;
  }
  .title2 {
    padding: 17.3px 13.54px 8.3px 13.54px;
    font-size: 14.58px;
    color: #17181A;
    opacity: 1;
    position: relative;
  }
  .title2::after {
    content: '';
    width: 4.17px;
    height: 15.63px;
    background-image: linear-gradient(-87deg, #FF4040 0%, #FF6547 55%, #FF7A68 100%);
    border-radius: 2.6px;
    position: absolute;
    top: 50%;
    transform: translateY(-28%);
    left: 1px;
  }
  .margin15 {
    margin-top: 15px;
  }
  .td {
    padding: 5px;
    text-align: center;
  }
}
</style>
